// login
import axios from './axiostwo.js'

// 后台登录接口
export function Login(data) {
    return axios.post('/open/v3/login_check', data)
}

export function getImgCode(data) {
    return axios.get('/open/code', { params: data })
}




// WEBPACK FOOTER //
// ./src/api/LoginApi.js